// @flow
import type { AxiosPromise } from 'axios';
import AxiosClient from '../AxiosClient';
import type { ExternalServiceAccessRestrictionPeriod } from './ExternalServiceAccessRestriction';

export default class ExternalServiceAccessRestrictionClient extends AxiosClient {
  fetchPeriod(
    serviceName: string,
  ): AxiosPromise<ExternalServiceAccessRestrictionPeriod> {
    return this.client.get(
      `external_service_access_restrictions/${serviceName}/period`,
    );
  }
}
